import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useQueryWithErrorHandling } from 'customHooks/errorHandling';
import { USER_WORK_LOCATIONS_QUERY } from '../queries';

export const canEditDocumentWorkLocation = document => !document.documentId || !document.clientSelected;

export const useUserWorkLocations = canEditWorkLocation => {
  const { data, loading } = useQueryWithErrorHandling(USER_WORK_LOCATIONS_QUERY, {
    skip: !canEditWorkLocation
  });

  const workLocations = useMemo(() => data?.userWorkLocations ?? [], [data]);
  const hasActiveConfig = workLocations.length > 0;

  return { workLocations, hasActiveConfig, loading };
};

export const useWorkLocationMandatory = document => {
  const offerHeader = useSelector(state => state.currentOffer.header, shallowEqual);
  const canEditWorkLocation = canEditDocumentWorkLocation(document);
  const { hasActiveConfig } = useUserWorkLocations(canEditWorkLocation);

  const hasStagedValue = document.userPartnerId != null && document.workLocationId != null;
  const hasSavedValue = document.documentId && offerHeader?.responsiblePartnerId != null && offerHeader?.workLocationId != null;

  return canEditWorkLocation && hasActiveConfig && !hasStagedValue && !hasSavedValue;
};
